/**
 * Simple EventEmitter for browser use
 */
export class EventEmitter {
    private events: Map<string, Set<Function>> = new Map();

    on(event: string, callback: Function): void {
        if (!this.events.has(event)) {
            this.events.set(event, new Set());
        }
        this.events.get(event)!.add(callback);
    }

    off(event: string, callback: Function): void {
        this.events.get(event)?.delete(callback);
    }

    emit(event: string, ...args: any[]): void {
        this.events.get(event)?.forEach(callback => callback(...args));
    }
}
